import { format } from 'date-fns';

import toggleTableColumns from './toggleTableColumns';

const defaultColumns = [
    { value : 'project_number', label : 'Projektnummer' },
    { value : 'addresses', label : 'Adresser totalt' },
    { value : 'signed_addresses', label : 'Antal HC' },
    { value : 'not_activated_signed_addresses', label : 'Kvar att driftsätta' },
    { value : 'delivery_manager', label : 'Projektledare' },
    { value : 'status', label : 'Status' },
    { value : 'deadline', label : 'Deadline' },
];

const allColumns = [
    ...defaultColumns,
    { value : 'latest_mailshot', label : 'Senaste utskick' },
    { value : 'ep_dig', label : 'Entreprenör gräv' },
    { value : 'ep_installation', label : 'Entreprenör installation' },
    { value : 'ep_activation', label : 'Entreprenör driftsättning' },
];

const columnValuesMapping = (project, column) => {
    switch (column.value) {
        case 'addresses':
            return valueWithFallback(project['addresses_count']);
        case 'signed_addresses':
            return valueWithFallback(project['signedAddresses']);
        case 'not_activated_signed_addresses':
            return valueWithFallback(project['notActivatedAddresses']);
        case 'delivery_manager':
            return project['delivery_manager'] ? project['delivery_manager']['name'] : '-';
        case 'status':
            return valueWithFallback(project['status_text']);
        case 'deadline':
            return project['deadline'] ? format(project['deadline'], 'YYYY-MM-DD') : '-';
        case 'latest_mailshot':
            if (! project.latest_mailshot) {
                return '-';
            }

            const mailshot = project.latest_mailshot;
            const subject = mailshot.subject;
            if (! mailshot.sent_at) {
                return `${subject} (ej skickat)`;
            }

            return `${subject} (${format(mailshot.sent_at, 'YYYY-MM-DD')})`;
        case 'ep_dig':
            return project['dig_phase_company'] ? project['dig_phase_company']['name'] : '-';
        case 'ep_installation':
            return project['installation_phase_company'] ? project['installation_phase_company']['name'] : '-';
        case 'ep_activation':
            return project['activation_phase_company'] ? project['activation_phase_company']['name'] : '-';
        default:
            return valueWithFallback(project[column.value]);
    }
};

const valueWithFallback = (value) => value ? value : '-';

export default {
    namespaced: true,
    state: {
        ...toggleTableColumns.state,
        storeName: 'deliveryProjectsTable',
        selectedColumns: [],
        defaultColumns,
        allColumns,
    },
    getters: {
        ...toggleTableColumns.getters,
        mappedColumnValue: () => (model, column) => columnValuesMapping(model, column),
    },
    actions: toggleTableColumns.actions,
    mutations: toggleTableColumns.mutations,
};
